<template>
  <div id="tasks">
      <div class="md-layout-column">
        <!-- <h2 class="tab-title" style="margin-bottom:20px">{{ 'My Transactions' }}</h2>
        <hr> -->
        <div class="md-layout md-gutter md-alignment-center-center">
          <div class="md-layout-item" style="margin-bottom: 10px" v-if="tasksType==='pending'">
              <div class="md-layout md-gutter md-alignment-center-center">

                  <md-chip :class="(stateSelect.includes(2)||stateSelect.includes(1)) ? 'md-primary' : ''" @click="changeState(2);changeState(1)"  md-clickable>{{'To first approve'}}</md-chip>
                  <md-chip :class="(stateSelect.includes(3)||stateSelect.includes(4)) ? 'md-primary' : ''" @click="changeState(3);changeState(4);"  md-clickable>{{'To sign'}}</md-chip>
                  <md-chip :class="stateSelect.includes(5) ? 'md-primary' : ''" @click="changeState(5)"  md-clickable>{{'To final approve'}}</md-chip>
             
                </div>
          </div>
          <div class="md-layout-item" style="margin-bottom: 10px" v-if="tasksType==='completed'">
              <div class="md-layout md-gutter md-alignment-center-center">
           <md-chip :class="stateCompletSelect.includes(6) ? 'md-primary' : ''" @click="changeCompletedState(6)"  md-clickable>{{'Approved'}}</md-chip>
                  <md-chip :class="stateCompletSelect.includes(8) ? 'md-primary' : ''" @click="changeCompletedState(8)"  md-clickable>{{'Rejected'}}</md-chip>
              </div>
          </div>
          <div class="md-layout-item " style="margin-bottom: 10px">

              <div class="md-layout md-gutter md-alignment-center-center" style="margin: 10px;">
                  <md-chip @click="showDateRangeDialog = true;" md-clickable>
                    <span style="padding: 15px;" v-if="selectedStartDate && selectedStartDate != ''"><b>From: </b> {{ dateFormatInit }}</span>

                    <span style="padding: 15px;" v-if="selectedEndDate && selectedEndDate != ''"><b>To: </b> {{ dateFormatEnd }}</span>

                  </md-chip>

              </div>
          </div>
          <!-- <div class="md-layout-item">
            <h5>Action</h5>
            <md-chip :class="actionSelect.includes('sign') ? 'md-primary' : ''" @click="changeAction('sign')"  md-clickable>Sign</md-chip>
            <md-chip :class="actionSelect.includes('approve') ? 'md-primary' : ''" @click="changeAction('approve')"  md-clickable>Appove</md-chip>
          </div> -->
          <md-field class="md-layout-item md-size-20" style="margin-bottom: 10px;">
              <label>Search</label>
              <md-input v-model="searchText" />
          </md-field>
          <div class="md-layout-item">
              <md-button class="md-icon-button md-primary" @click="findTasks();findCompleted();">
                <md-icon>search</md-icon>
              </md-button>
          </div>
        </div>
    <md-tabs @md-changed="changeTab" class="md-transparent">

      <md-tab id="pending" md-label="Pending Tasks ">
        
        <tasks-table :searchFilters="pendingFilters" />
      </md-tab> 
      <md-tab id="completed" md-label="Completed">
        <tasks-table :searchFilters="completedFilters" />

      </md-tab>

    </md-tabs>
        <md-dialog :md-active.sync="showDateRangeDialog">
            <md-dialog-title class="md-dialog-title">Date Range</md-dialog-title>
            <div class="dialog-content spaced">
                <div class="md-layout ">

                
                    <CustomDateField  class="md-layout-item" label="Select staring date" v-model="selectedStartDate"/>
                </div>
                <div class="md-layout ">
                  <CustomDateField class="md-layout-item"  label="Select ending date" v-model="selectedEndDate"/>
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-accent" @click="showDateRangeDialog = false">Close</md-button>
                <md-button class="md-primary" @click="showDateRangeDialog = false;changeDate('range');" 
                :disabled="!validDateFilter">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from "vue";
import TasksTable from '../components/TasksTable.vue';
import CustomDateField from "@/components/CustomDateField.vue";
export default {
  components: {
    TasksTable,
    CustomDateField
  },
  data ()   {
    return {
      dateTimeFormat: Vue.prototype.$generalConfiguration['dateTimeFormat'],
      dateFormat: Vue.prototype.$generalConfiguration['dateFormat'],
      tableData : [],
      searchText : "",
      labelsState : ['Initial','Released', 'Sent','Sign','Signed'],
      stateSelect : [1,2,3,4,5],
      stateCompletSelect : [6,8],
      actionSelect : ['sign','approve'],
      selected: {},
      role: null,
      showDateRangeDialog:false,
      selectedStartDate: moment().add(-3, 'months').toDate(),
      selectedEndDate: moment().toDate(),
      tasksType:'pending',
      pendingFilters:{},
      completedFilters:{}
    }
  },
  methods: {
    changeCompletedState(state){
      var index = this.stateCompletSelect.indexOf(state);
      if(index > - 1){
        this.stateCompletSelect.splice(index, 1);
      }else{
        this.stateCompletSelect.push(state);
      }
      this.findCompleted();
    },
    changeState(state){
      var index = this.stateSelect.indexOf(state);
      if(index > - 1){
        this.stateSelect.splice(index, 1);
      }else{
        this.stateSelect.push(state);
      }
      this.findTasks();
    },
    changeAction(action){
      var index = this.actionSelect.indexOf(action);
      if(index > - 1){
        this.actionSelect.splice(index, 1);
      }else{
        this.actionSelect.push(action);
      }
    },
    changeDate(dateRange){
      this.dateFilter = dateRange;
      this.findTasks();
      this.findCompleted();
    },

    getPermission(name){
      const permissions = Vue.prototype.$userData.permissions|| [];
      if ( !permissions.includes(name)) {
            this.$router.push("Landing");
        }
    },
    changeTab(activeTab){
      this.tasksType = activeTab;
    },
    findTasks(){
        this.pendingFilters = {
          userId: Vue.prototype.$userData.user.id,
          status: this.stateSelect,
          // actionsFilter: this.actionSelect,
          dateInit: moment(this.selectedStartDate).format('YYYY-MM-DDT00:00:00Z'),
          dateEnd: moment(this.selectedEndDate).format('YYYY-MM-DDT23:59:59Z'),
          searchText: this.searchText
        }
 
      },
    findCompleted(){
        this.completedFilters = {
          userId: Vue.prototype.$userData.user.id,
          status: this.stateCompletSelect,
          dateInit: moment(this.selectedStartDate).format('YYYY-MM-DDT00:00:00Z'),
          dateEnd: moment(this.selectedEndDate).format('YYYY-MM-DDT23:59:59Z'),
          searchText: this.searchText
        }
 
      }
  },
  mounted(){
    this.role =Vue.prototype.$userData.user.role[0];
    this.findTasks()
    this.findCompleted()
  },
  computed:{
    validDateFilter() {
      return   moment().isValid() || moment(this.selectedEndDate).isValid();
    },
    dateFormatInit() {
      return moment(this.selectedStartDate).format(this.dateFormat)
    },
    dateFormatEnd() {
      return moment(this.selectedEndDate).format(this.dateFormat)
    }
  }
}
</script>

<style lang="scss">
  .md-table + .md-table {
    margin-top: 16px
  }
.dialog-content{
    margin: 20px; 
    padding: 0px;
}

.md-dialog-title{
    background-color:#e94e1b; 
    margin: 0px; 
    padding: 20px; 
    color: white
}

.md-selected-row{
  background-color: #dddddd !important;
}
.md-progress-bar.md-determinate.md-theme-default{
  background-color: #8b7b7b !important;
  height: 8px;

}

</style>